<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <div class="top_cent_p">
              <i class="el-icon-location"></i>
              <el-dropdown trigger="click" class="koaa">
                <!-- <span class="el-dropdown-link" v-if="namee == ''">
              天津市
              <i class="el-icon-arrow-down el-icon--right"></i>
                </span>-->
                <span class="el-dropdown-link">
                  {{getCitys[citr].city_name}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="koa">
                  <el-dropdown-item
                    v-for="(item,index) in getCitys"
                    :key="index"
                    @click.native="dropdown(item.id,index)"
                  >{{item.city_name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <i class="el-icon-arrow-down icon"></i> -->
            </div>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{name:'login'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li @click="dialogVisible = true">
              <a href="#">登录</a>
            </li>
            <li>|</li>
            <li @click="dialogVisible1 = true">
              <a href="#">注册</a>
            </li>
            <li>
              <a href="https://coc.sqifu.com" target="_blank">商会后台</a>
            </li>
            <router-link :to="{path:'/fuwushang'}" tag="li">
              <a href="#">卖家中心</a>
            </router-link>
            <li>
              <a href="http://zf.sqifu.com">政府机构</a>
            </li>
            <li v-if="citr ==0 ">
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
            <li v-if="citr == 1 ">
              <i class="el-icon-phone"></i>0934--8612991
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="cent">
      <img src="../../assets/img/zhengwu/government_bg_top.png" alt />
      <div class="cent_1" v-if="getCitys[citr].city_name">
        <p>{{getCitys[citr].city_name}}</p>
      </div>
    </div>
    <div class="cent1">
      <div class="cent1_1">
        <ul>
          <li @click="zhngwu()">
            <a href="#">首页</a>
          </li>
          <li @click="zhitongche()" style="background: #e40000;">
            <a href="#">政企直通车</a>
          </li>
          <li @click="business()">
            <a href="#">办事指南</a>
          </li>
          <li @click="shanhui()">
            <a href="#">商会</a>
          </li>
          <li @click="fuwu()">
            <a href="#">服务</a>
          </li>
          <li @click="guanyu()">
            <a href="#">关于平台</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- 内容 -->
    <div class="content">
      <div class="content_1">
        <div class="content_top">
          <ul>
            <router-link :to="{path:'/zhengwu'}" tag="li">
              <a href="#">当前位置: 首页</a>
            </router-link>
            <li>
              <i class="el-icon-arrow-right"></i>
            </li>
            <router-link :to="{name:'zhitongche'}" tag="li">
              <a href="#">政务直通车</a>
            </router-link>
            <li>
              <i class="el-icon-arrow-right"></i>
            </li>
            <li>
              <a href="#">政务机构名称</a>
            </li>
          </ul>
        </div>
        <div class="content_floor">
          <div class="content_floor_top">
            <p class="zhen">政企直通车说明</p>
            <div class="content_floor_cent">
              <p>为了进一步优化庆阳市营商环境，促进民营经济发展，加强政府与企业的联系，推进政务公开，促进依法行政，庆阳市非公经济领导办公室特开设庆阳市政商直通车平台，受理庆阳市民营企业发展遇到的问题和对政府各部分工作意见建议及相关咨询。根据有关规定，特制定本规则。</p>
              <p>一、政企直通车受理范围为</p>
              <p>&nbsp;&nbsp;&nbsp;（一）企业对我市各级政府及其工作部门的意见和建议；</p>
              <p>&nbsp;&nbsp;&nbsp;（二）对我市各级政府部门工作人员工作效率、工作质量、工作作风方面的意见和建议；</p>
              <p>&nbsp;&nbsp;&nbsp;（三）对我市改革开放、经济建设、城市管理、社会事业等方面的意见和建议；</p>
              <p style="margin-bottom:20px;">&nbsp;&nbsp;&nbsp;（四）企业经营中发生的应由政府及其工作部门解决的有关问题。</p>
              <p>二、对所有信息以受理为原则，不受理为例外。对以下来信，可以不予受理：</p>
              <p>&nbsp;&nbsp;&nbsp;（一）主体不明，内容不具体，无法核实的；</p>
              <p>&nbsp;&nbsp;&nbsp;（二）属于民事、经济等个人问题，与政府职责无关的；</p>
              <p>&nbsp;&nbsp;&nbsp;（三）不属政府管理权限范围的；</p>
              <p>&nbsp;&nbsp;&nbsp;（四）已进入仲裁、司法程序的；</p>
              <p style="margin-bottom:20px;">&nbsp;&nbsp;&nbsp;（五）已定性且实行终结处理的。</p>
              <p
                style="margin-bottom:20px;text-indent: 20px;"
              >三、非公经济领导小组办公室具体负责政企直通车来信受理工作。来信反映属于各有关部门、单位职责范围内的问题，由非公经济领导小组办公室转有有关部门、单位承办；对事关我区国民经济和社会发展全局的重大紧急事项，根据来信内容分别报市长、分管市长长批示。</p>
              <p
                style="margin-bottom:20px;text-indent: 20px;"
              >对于您的来信我们将会交与相关的部门进行处理。一般收到信件后会在七个工作日内进行回复，若暂时无法回复的，我们会与您直接联系，请您准确写明联系电话和电子邮件地址。</p>
              <!-- <div class="dist">
                <p>
                  <img src="../../assets/img/pop_btn_xy_nor.png" @click="munn()" v-show="num1==2" />
                  <img src="../../assets/img/pop_btn_xy_sel.png" @click="munn1()" v-show="num1==1" />
                </p>
                <p>我已阅读，并承诺反馈的信息真实合法</p>
              </div> -->
            </div>
          </div>
          <div class="buto">
            <button @click="down()">我已阅读，并承诺反馈的信息真实合法</button>
          </div>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li @click="floor">
            <a href="#">关于商企服</a>
          </li>
          <li @click="leimu()">
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getLoginphone,
  getLogin,
  getRegionList,
  getLogon,
  getToken
} from "@/http/api";
export default {
  data() {
    return {
      total1: 0,
      getCitys: [],
      getokens: [],
    };
  },
  methods: {
    // 跳转
    floor() {
      this.$router.push({ name: "guanyu" });
    },
    leimu() {
      this.$router.push({ name: "home" });
    },
    zhitongche() {
      this.$router.push({
        name: "zhitongche"
      });
    },
    business() {
      this.$router.push({
        name: "business"
      });
    },
    shanhui() {
      this.$router.push({
        name: "shanhui"
      });
    },
    guanyu() {
      this.$router.push({
        name: "guanyupingtai"
      });
    },
    fuwu() {
     this.token = localStorage.getItem("token");
      this.$http(
        "https://coc.sqifu.com/WebProgram/Base/checklogin",
        {
          token: this.token
        },
        "post"
      ).then(res => {
        if (res.data.errcode === 20001) {
           this.$router.push({
            name: "login"
          });
        } else {
          this.$router.push({
            name: "home"
          });
        }
      });
    },
    zhngwu() {
      this.$router.push({
        name: "zhengwu"
      });
    },
    checlogin() {
      this.token = localStorage.getItem("token");
      this.$http(
        "https://coc.sqifu.com/WebProgram/Base/checklogin",
        {
          token: this.token
        },
        "post"
      ).then(res => {
        if (res.data.errcode === 20001) {
          this.$emit("header", false); //是否显示头部
        } else {
          this.$emit("header", true); //是否显示头部
        }
      });
    },
    zixun(id) {
      this.token = localStorage.getItem("token");
      this.id = localStorage.getItem("city_id");
      var nan = window.location.href;
      this.$http(
        "https://coc.sqifu.com/WebProgram/Base/checklogin",
        {
          token: this.token
        },
        "post"
      ).then(res => {
        if (res.data.errcode === 20001) {
          alert("请先登录");
        } else if (this.getokens.identity == 0) {
          this.$message({
            message: "请先认证会员",
            type: "success"
          });
        } else {
          if (this.id == "1") {
            this.$router.push({
              name: "advice",
              query: {
                id: id
              }
            });
          } else if (this.id == "26" || nan == "https://qy.sqifu.com/#/") {
            this.$router.push({
              name: "qyadvice",
              query: {
                id: id
              }
            });
          }
        }
      });
    },
    ticle(id) {
      this.$router.push({
        name: "article",
        query: {
          ids: id
        }
      });
    },
    getCity() {
      this.$http("https://ctapi.sqifu.com/api/v1/getCityList", {}, "post").then(
        res => {
          this.getCitys = res.data.data;
        }
      );
    },
    dropdown(id, index) {
      this.citr = index;
      localStorage.setItem("city_id", id);
      localStorage.setItem("citr", this.citr);
      this.$router.go(0);
    },
    gettoken() {
      this.id = localStorage.getItem("token");
      getToken({
        token: this.id
      }).then(res => {
        this.getokens = res.data.data;
      });
    },
    down(num1) {
      this.$router.push('qyadvice')
    }
  },
  created() {
    this.checlogin();
    this.citr = localStorage.getItem("citr");
    this.getCity();
    this.gettoken();
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
  float: left;
}

.icon {
  color: #000;
}

.top_ul {
  width: auto;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.cent {
  width: 100%;
  height: 96px;
  position: relative;
}

.cent img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.cent_1 {
  width: 1200px;
  height: 96px;
  margin: 0 auto;
}

.cent_1 p {
  font-size: 32px;
  color: #fff;
  line-height: 96px;
  font-weight: 600;
}

.cent1 {
  width: 100%;
  height: 40px;
  background: #1369c0;
}

.cent1_1 {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.cent1_1 ul li {
  float: left;
  width: 199px;
  height: 40px;
  border-right: 1px solid #71a5d9;
  line-height: 40px;
  text-align: center;
}

.cent1_1 ul li:hover {
  background: #e40000;
  height: 40px;
  margin: 0;
  line-height: 40px;
}

.cent1_1 ul li a {
  width: 200px;
  color: #fff;
}

.cent1_1 ul li:nth-child(6) {
  border: 0;
}

.content {
  width: 100%;
  height: auto;
  margin-bottom: 100px;
}

.content_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.content_one {
  width: 100%;
  height: 36px;
  margin: 30px 0;
}

.content_top {
  width: 1200px;
  height: 40px;
  background: rgba(244, 245, 249, 1);
  border: 1px solid rgba(228, 228, 228, 1);
  border-radius: 2px;
  margin-bottom: 46px;
}

.content_top ul {
  padding: 0 10px;
}

.content_top ul li {
  float: left;
  color: #666666;
  line-height: 40px;
  margin-left: 5px;
}

.content_top ul li a {
  color: #666666;
}

.content_floor {
  width: 960px;
  height: 650px;
  margin: 0 auto;
}

.content_floor_top {
  width: 100%;
  height: 604px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(228, 228, 228, 1);
  border-radius: 2px;
}

.zhen {
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(34, 34, 34, 1);
  text-align: center;
  margin: 20px 0;
}

.content_floor_cent {
  width: 863px;
  height: auto;
  margin: 0 auto;
}

.content_floor_cent p {
  font-size: 14px;
  margin-bottom: 5px;
  color: #666666;
}

.content_floor_cent p:nth-child(1) {
  text-indent: 20px;
  margin-bottom: 30px;
}

.dist {
  width: 300px;
  margin: 0 auto;
}

.dist img {
  padding: 5px 10px;
}

.dist p {
  float: left;
  line-height: 26px;
}

.buto {
  width: 360px;
  height: 44px;
  margin: 40px auto;
}

.buto button {
  width: 360px;
  height: 44px;
  background: rgba(0, 123, 255, 1);
  border-radius: 4px;
  border: 0;
  outline: 0;
  color: #fff;
  font-size: 16px;
}
</style>
 


// WEBPACK FOOTER //
// src/view/Zhengwu/Consultation.vue